import React, { useState } from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  FormControlLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import useInstructionsStyles from "../../instructionStyle/default/InstructionsStyles";
import { useLanguages } from "../../../../context/LanguagesContext";

function Popup({
  showPopup,
  setShowPopup,
  popupInstructions,
  handlePopupNext,
  setAgree,
  agree,
}) {
  const classes = useInstructionsStyles();

  const { languages, handleChange, selectedLanguage } = useLanguages();

  return (
    <Dialog open={showPopup}
     onClose={() => setShowPopup(false)}
     >
      <DialogContent className={classes.popupModal}>
        <Typography color="error" align="center" className={classes.popupNote}>
          Please Note All Questions Will Appear In Your Default Language. This
          Language Can Be Changed For A Particular Question Later On.
        </Typography>

        <div className={classes.checkboxSection} >
          <FormControlLabel
          style={{height:'20px',marginRight:'0px' }}
            control={
              <Checkbox
                checked={agree}
                onChange={() => setAgree(!agree)}
                color="primary"

              />

            }
            />
            <Typography variant="body2">{popupInstructions}</Typography>
        </div>
        <div className={classes.popupActions}>
          <Select
            value={selectedLanguage}
            onChange={handleChange}
            size="small"
            className={classes.langSelect}
          >
            {languages?.map((l) => (
              <MenuItem value={l.value}>{l.label}</MenuItem>
            ))}
          </Select>
          <Button variant="contained" color="primary" onClick={handlePopupNext}>
            Next
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default Popup;
